import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, HostListener, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbTooltip, NgbInputDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment";

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit {
  @Input() field: any;
  @ViewChild('invalidTooltip') invalidTooltip: NgbTooltip;
  @ViewChild('d') d: NgbInputDatepicker;
  pattern: string;
  patternErrorMsg: string;
  fCtrl: FormControl;
  minDate:any;
  maxDate:any;

  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    if(this.field.bepoz_field_name == 'DateBirth'){
      this.minDate = {year: moment().year()-120, month: 1, day: 1};
      this.maxDate = {year: moment().year(), month: moment().month()+1, day: moment().date()};
      console.log(this.minDate, this.maxDate);
    }
    this.pattern = '';
    this.patternErrorMsg = `Please enter a valid Date.`;
    console.log(this.d);
    
    if (this.field.required) {
      this.fCtrl = new FormControl('', [Validators.required, Validators.pattern(this.pattern)]);
    } else {
      this.fCtrl = new FormControl();
    }

    //listening input state changes
    this.fCtrl.statusChanges.subscribe(status => {
      // console.log(status);
      if (status == 'INVALID' && (this.fCtrl.dirty || this.fCtrl.touched)) {
        this.invalidTooltip.open();
        // console.log(this.fCtrl);
      }
      if (status == 'VALID') {
        this.invalidTooltip.close();
      }
    });


    //pass formcontrol to field obj
    this.field.formControl = this.fCtrl;
    this.field.invalidTooltip = this.invalidTooltip;
  }

  dateOnSelected(date:any){
    // console.log(moment(`${date.year}-${date.month}-${date.day}`, 'YYYY-MM-DD').format('YYYY-MM-DD'));
    // this.field['value'] = new Date(date.year, date.month-1, date.day).toString();
  }

  //when focus:blur check input status
  onFocusOutCheck(event) {
    if (this.fCtrl.invalid) {
      this.invalidTooltip.open();
    }
    // this.d.close();
  }

  @HostListener('document:click', ['$event'])
  clickout(event){
    if(!this.elRef.nativeElement.contains(event.target)) {
      this.d.close();
      console.log('pick close');
    } 
  }


}
